import { colors } from "../../Styles";

export function Fetch({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <g transform="matrix(1.19201,0,0,1.19201,-27.2191,-17.2191)">
          <path d="M96.59,141.26L130,141.26L78.81,85.56L29.76,140.95L59.97,140.95C59.97,140.95 70.28,251.72 166.61,217.94C166.61,217.94 100.85,223.28 96.58,141.27L96.59,141.26Z"/>
      </g>
      <g transform="matrix(1.19201,0,0,1.19201,-27.2191,-37.2191)">
          <path d="M223.49,142.52C223.49,142.52 213.18,31.75 116.85,65.53C116.85,65.53 182.61,60.19 186.88,142.2L153.47,142.2L204.66,197.9L253.71,142.51L223.5,142.51L223.49,142.52Z"/>
      </g>
    </svg>
  );
}
